module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Title1"
  }, [_vm._v("LAST CHANCE TEXACO")]), _vm._v(" "), _c('p', {
    staticClass: "TitleSub"
  }, [_vm._v("Chronicles of an American Troubadour")]), _vm._v(" "), _c('p', {
    staticClass: "TitleAuthor"
  }, [_vm._v("RICKIE")]), _vm._v(" "), _c('p', {
    staticClass: "TitleAuthor2"
  }, [_vm._v("LEE")]), _vm._v(" "), _c('p', {
    staticClass: "TitleAuthor2"
  }, [_vm._v("JONES")]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/V-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-para ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Grove Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-para ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe5c931","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802188809-1.vue
// module id = 66
// module chunks = 0